(() => {
  "use strict";

  const SPLASH_ID = "senkaimon";

  let started = false;
  let cleanupTimer = null;

  function initSenkaimon() {
    if (started) return;

    const splash = document.getElementById(SPLASH_ID);

    if (!splash) {
      document.documentElement.classList.remove("senkaimon-active");
      return;
    }

    started = true;

    const root = document.documentElement;

    root.classList.add("senkaimon-active");

    /*
      ----------------------------------------------------------
      TIMELINE

      0ms
      World visible / gate closed

      500ms
      Cinematic camera drift begins

      1250ms
      Portal wakes behind doors

      1550ms
      Doors open

      2050ms
      Title appears as light grows

      3200ms
      Title begins disappearing

      3380ms
      Full-screen flash begins

      3820ms
      Environment removed UNDER flash

      3950ms
      Flash fades directly into website

      4800ms
      Splash completely removed
      ----------------------------------------------------------
    */


    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        splash.classList.add("is-awake");
      });
    });


    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("portal-visible");
    }, 1250);


    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("doors-opening");
    }, 1550);


    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("title-visible");
    }, 2050);


    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("title-leaving");
    }, 3200);


    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("flash-visible");
    }, 3380);


    /*
      By this point the flash is opaque.

      NOW we hide the gate/sky/doors behind it.

      This is what prevents:
      flash -> gate appears again -> website

      Instead:
      gate -> flash -> website
    */

    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("environment-gone");
    }, 3820);


    /*
      Fade the actual overlay away.
      Since the environment is already hidden,
      the real Shopify page is what appears underneath.
    */

    window.setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("reveal-site");

      root.classList.remove("senkaimon-active");
    }, 3950);


    cleanupTimer = window.setTimeout(() => {
      removeSenkaimon();
    }, 4800);
  }


  function removeSenkaimon() {
    const splash = document.getElementById(SPLASH_ID);

    document.documentElement.classList.remove("senkaimon-active");

    if (splash) {
      splash.remove();
    }

    if (cleanupTimer) {
      clearTimeout(cleanupTimer);
      cleanupTimer = null;
    }
  }


  /*
    Normal page load
  */

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initSenkaimon,
      { once: true }
    );
  } else {
    initSenkaimon();
  }


  /*
    Shopify/theme navigation safety.

    Some themes manipulate page content without behaving like
    an old-school full refresh. These listeners prevent an
    orphaned splash from trapping the screen.
  */

  window.addEventListener("pageshow", () => {
    const splash = document.getElementById(SPLASH_ID);

    if (splash && !started) {
      initSenkaimon();
    }
  });


  /*
    Absolute failsafe.

    Even if something unexpected interrupts the animation,
    the splash cannot permanently cover the store.
  */

  window.setTimeout(() => {
    const splash = document.getElementById(SPLASH_ID);

    if (splash) {
      removeSenkaimon();
    }
  }, 6500);

})();